import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-14 sm:py-24 px-4 bg-brand-red relative overflow-hidden text-center" data-id="element-39">
      {/* Dark overlay for depth */}
      <div className="absolute inset-0 bg-black/40" data-id="element-40" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-42">
          <h2 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white mb-6 sm:mb-10 text-shadow-lg" data-id="element-43">
            BECAUSE HISTORY REMEMBERS THE BOLD, NOT THE SILENT.
          </h2>

          <CTAButton scrollTo="pricing" className="bg-black border-brand-gold text-brand-gold hover:bg-black/90 hover:border-white hover:text-white shadow-2xl text-base sm:text-2xl py-5 sm:py-6 px-6 sm:px-12" data-id="element-44">
            YES, I WANT THE EBOOK &amp; BONUSES — INSTANT ACCESS FOR $17
          </CTAButton>

          <p className="mt-5 sm:mt-8 text-white/80 font-oswald tracking-widest text-xs sm:text-sm uppercase" data-id="element-45">
            Instant Download • 7-Day Money-Back Guarantee • 100% Secure
          </p>
        </motion.div>
      </div>
    </section>;
}